import { Component, input } from '@angular/core';
import { RevisionService } from '../../projects.service';
import { StatusSidebar } from '@app/shared/components/status-sidebar/status-sidebar';

@Component({
  selector: 'app-revision-status',
  imports: [StatusSidebar],
  templateUrl: './revision-status.html',
  styleUrl: './revision-status.scss'
})
export class RevisionStatus {
  revisionId = input<string | null>(null);
  
  // Configuration for revision status
  revisionConfig = {
    type: 'revision' as const,
    title: 'Manage Revision',
    statusLabel: 'Status',
    assignLabel: 'Assigned To',
    plannedHoursLabel: 'Planned Hours',
    dueDateLabel: 'Due on',
    refNumberLabel: 'Ref No.',
    showPlannedHours: true,
    showDueDate: true,
    showRefNumber: true,
    showApprovals: true,
    showTimeSummary: true,
    customFields: []
  };

  constructor(public revisionService: RevisionService) {}
}
